module.exports = __webpack_public_path__ + "img/home-white.37b19659.svg";